import { AnnotationsTooltipProps } from '../../core/components/annotations/components/tooltip/types/annotations-tooltip-props.js';

export const Tooltip = (props: AnnotationsTooltipProps) => null;

Tooltip['displayName'] = 'AnnotationsChart.Tooltip';
